@let labelText = label();
@let iconNameValue = iconName();
@let iconWeightValue = iconWeight();
@let isLoading = loading();
@let hrefValue = href();
@let showAsDisabled = disabled() || isLoading;
@let classes =
  {
    'relative flex w-full flex-row items-center justify-center gap-2.5 overflow-hidden font-medium duration-150': true,
    'cursor-not-allowed': showAsDisabled,
    'cursor-pointer': !showAsDisabled,
    'hover:bg-d-medium-shine/25': !showAsDisabled && !color(),
    'hover:bg-[#dddddd]': !showAsDisabled && color() == 'd-light',
    'text-d-medium-shine': showAsDisabled && (color() == 'd-light' || !color()),
    'text-d-slate-main': !showAsDisabled && (color() == 'd-light' || !color()),
    'bg-d-secondary-main hover:bg-d-secondary-shade text-d-secondary-contrast': !showAsDisabled && color() == 'd-secondary',
    'bg-d-light-shade text-d-light-main': (showAsDisabled && color() == 'd-secondary') || color() == 'd-light',
    'bg-d-primary-main hover:bg-d-primary-shade text-d-primary-contrast': !showAsDisabled && color() == 'd-primary',
    'bg-d-primary-shine': showAsDisabled && color() == 'd-primary',
    'bg-d-red-main hover:bg-d-red-shade text-d-red-contrast': !showAsDisabled && color() == 'd-red',
    'bg-d-red-shine': showAsDisabled && color() == 'd-red',
    'bg-d-green-main hover:bg-d-green-shade text-d-green-contrast': !showAsDisabled && color() == 'd-green',
    'bg-d-green-shine': showAsDisabled && color() == 'd-green',
    'text-d-light-shade': showAsDisabled && (color() == 'd-red' || color() == 'd-green' || color() == 'd-primary'),
    'min-w-32': minWidth() == '32',
    'px-2 py-1 text-sm': size() == 'sm' && labelText,
    'px-4 py-2 text-base': size() == 'md' && labelText,
    'px-6 py-3 text-lg': size() == 'lg' && labelText,
    'p-1': size() == 'sm' && !labelText,
    'p-2': (size() == 'md' || size() == 'lg') && !labelText,
    'rounded-md': size() == 'sm',
    'rounded-lg': size() == 'md' || size() == 'lg'
  };
@if (hrefValue) {
  <a
    [href]="hrefValue"
    [attr.target]="target()"
    [ngClass]="classes"
    [class.pointer-events-none]="showAsDisabled"
    [attr.aria-disabled]="showAsDisabled"
  >
    <ng-container *ngTemplateOutlet="contentElement"></ng-container>
  </a>
} @else {
  <button
    type="button"
    [tabIndex]="showAsDisabled ? -1 : 0"
    [disabled]="showAsDisabled"
    [ngClass]="classes"
    [class.pointer-events-none]="showAsDisabled"
    [attr.aria-disabled]="showAsDisabled"
    (click)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="contentElement"></ng-container>
  </button>
}

<ng-template #contentElement>
  <ng-container *ngTemplateOutlet="inlineIconElement"></ng-container>
  @if (labelText && labelText.length > 0) {
    <span>{{ labelText }}</span>
  }
</ng-template>

<ng-template #inlineIconElement>
  @if ((iconNameValue && iconWeightValue) || isLoading) {
    <gs-icon
      [iconName]="isLoading ? 'circle-notch' : iconNameValue || ''"
      [iconWeight]="isLoading ? 'fill' : iconWeightValue"
      [animation]="isLoading ? 'spin' : undefined"
      class="inline-block"
      [ngClass]="{
        'size-3 text-xs': size() === 'sm',
        'size-5 text-base': size() === 'md',
        'size-7 text-lg': size() === 'lg',
        'text-d-dark-main': isLoading
      }"
    ></gs-icon>
  } @else {
    <ng-content select="[inlineIcon]"></ng-content>
  }
</ng-template>
